export default __webpack_public_path__ + "static/media/img-5.b8917089.jpg";